<!-- Sign-up Form Page 2 -->
<section>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" (submit)="onSubmit(f.form)" #f="ngForm" novalidate>

            <!-- Header -->
            <h1 class="mb-3 text-center">Sign Up</h1>
            <p class="text-center" *ngIf="!user.ageUnder18">Fill in this form and click "Next" to continue to the next page.</p>
            <p class="text-center no-margin" *ngIf="user.ageUnder18">Fill in this form and click "Finish" to complete your registration with us!</p>
            <p class="text-center" *ngIf="user.ageUnder18"><small>$30 + processing fees to those with addresses outside of Nebraska.</small></p>
            <hr>

            <!-- Input Fields -->
            <div class="col-md-12">

                <!-- Input Row -->
                <div class="row mt-2">

                    <!-- First Name -->
                    <div class="col-md-5">
                        <label class="required-field">First Name</label>
                        <input type="text" id="firstName" class="form-control mb-2" [(ngModel)]="user.firstName" #firstName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" name="firstName" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && firstName.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="firstName.errors!.required">First name is required</div>
                        </div>
                    </div>

                    <!-- Middle Initial -->
                    <div class="col-md-2">
                        <label>MI</label>
                        <input type="text" id="middleInitial" class="form-control mb-2" [(ngModel)]="user.middleInitial" name="middleInitial">
                    </div>

                    <!-- Last Name -->
                    <div class="col-md-5">
                        <label class="required-field">Last Name</label>
                        <input type="text" id="lastName" class="form-control mb-2" [(ngModel)]="user.lastName" name="lastName" #lastName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && lastName.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="lastName.errors!.required">Last name is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="!user.ageUnder18">
                    <!-- Primary Role -->
                    <div [ngClass]="user.primaryRole === 'Other' || user.primaryRole === 'Housing Provider – Owner' || user.primaryRole === 'Housing Provider – Property Management' ? 'col-md-6' : 'col-md-12'">
                        <label class="required-field">Primary Role</label>
                        <select name="primaryRole" id="primaryRole" class="form-control mb-2" [(ngModel)]="user.primaryRole" name="primaryRole" #primaryRole="ngModel" [ngClass]="{ 'is-invalid': f.submitted && primaryRole.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option *ngFor="let role of primaryRoles" [ngValue]="role.value">{{ role.name }}</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && primaryRole.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="primaryRole.errors!.required">Role is required</div>
                        </div>
                    </div>

                    <!-- Primary Role: Other -->
                    <div class="col-md-6" *ngIf="user.primaryRole === 'Other'">
                        <label class="required-field">Other Role</label>
                        <input type="text" id="primaryRoleOther" class="form-control mb-2" [(ngModel)]="user.primaryRoleOther" #primaryRoleOther="ngModel" [ngClass]="{ 'is-invalid': f.submitted && primaryRoleOther.invalid }" name="primaryRoleOther" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && primaryRoleOther.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="primaryRoleOther.errors!.required">Other Role is required</div>
                        </div>
                    </div>

                    <!-- Company Name -->
                    <div class="col-md-6" *ngIf="user.primaryRole === 'Housing Provider – Owner' || user.primaryRole === 'Housing Provider – Property Management'">
                        <label class="required-field">Company Name</label>
                        <input type="text" id="companyName" class="form-control mb-2" [(ngModel)]="user.companyName" #companyName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && companyName.invalid }" name="companyName" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && companyName.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="companyName.errors!.required">Company Name is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="!user.ageUnder18">

                    <!-- Date of BirthNext -->
                    <div class="col-md-4">
                        <label class="required-field">Date of Birth</label>
                        <div class="input-group date_container">
                            <input class="form-control mb-2" matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" id="dob" name="dob" [(ngModel)]="user.dob" #dob="ngModel" [ngClass]="{ 'is-invalid': f.submitted && dob.invalid }" required>

                            <!-- Date Picker -->
                            <mat-datepicker startView="multi-year" #picker></mat-datepicker>
                            <mat-datepicker-toggle class="icon" matSuffix [for]="picker"></mat-datepicker-toggle>

                            <!-- Invalid -->
                            <div *ngIf="f.submitted && dob.invalid" class="invalid-feedback">
                                <div class="mb-2" *ngIf="dob.errors!.required">Date of birth is required</div>
                            </div>
                        </div>
                    </div>

                    <!-- Race TODO: Put this in a dropdown somehow? -->
                    <div [formGroup]="form" class="col-md-5 check">
                        <label class="required-field">Race</label>

                        <!-- List of Checkboxes of Races -->
                        <div *ngFor="let race of races; let i=index">
                            <input id="race_checkbox_{{i}}" type="checkbox" [value]="race.value" (change)="onCheckboxChange($event)" />
                            <label for="race_checkbox_{{i}}" class="ml-2">{{race.name}}</label>
                        </div>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && this.form.controls['checkArray'].invalid" class="invalid-feedback race">
                            <div class="mb-2" *ngIf="this.form.controls['checkArray'].errors?.required">At least one race is required</div>
                        </div>
                    </div>

                    <!-- Ethnicity -->
                    <div class="col-md-3">
                        <label class="required-field">Ethnicity</label>
                        <select name="isHispanic" id="isHispanic" class="form-control mb-2" [(ngModel)]="user.ethnicity" name="ethnicity" #ethnicity="ngModel" [ngClass]="{ 'is-invalid': f.submitted && ethnicity.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="Hispanic">Hispanic</option>
                            <option value="Arabic">Arabic</option>
                            <option value="None of these">None of these</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && ethnicity.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="ethnicity.errors!.required">Ethnicity is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="!user.ageUnder18">

                    <!-- Disability -->
                    <div class="col md-2">
                        <label class="required-field">Disability</label>
                        <select name="disabled" id="disabled" class="form-control mb-2" [(ngModel)]="user.disabled" name="disabled" #disability="ngModel" [ngClass]="{ 'is-invalid': f.submitted && disability.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && disability.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="disability.errors!.required">Disability is required</div>
                        </div>
                    </div>

                    <!-- Number of Children -->
                    <div class="col md-5">
                        <label class="required-field">Number of Children</label>
                        <select name="numberOfChildren" id="numberOfChildren" class="form-control mb-2" [(ngModel)]="user.numberOfChildren" name="numberOfChildren" #numberOfChildren="ngModel" [ngClass]="{ 'is-invalid': f.submitted && numberOfChildren.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7 or more">7 or more</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && numberOfChildren.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="numberOfChildren.errors!.required">Number of children is required</div>
                        </div>
                    </div>

                    <!-- Marital Status -->
                    <div class="col md-5">
                        <label class="required-field">Marital Status</label>
                        <select name="maritalStatus" id="maritalStatus" class="form-control mb-2" [(ngModel)]="user.maritalStatus" name="maritalStatus" #maritalStatus="ngModel" [ngClass]="{ 'is-invalid': f.submitted && maritalStatus.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="Married">Married</option>
                            <option value="Widowed">Widowed</option>
                            <option value="Divorced or Seperated">Divorced or Seperated</option>
                            <option value="Never Married or Single">Never Married or Single</option>
                            <option value="Domestic Partnership">Domestic Partnership</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && maritalStatus.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="maritalStatus.errors!.required">Marital status is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="!user.ageUnder18">

                    <!-- Family Status -->
                    <div class="col md-6">
                        <label class="required-field">Family Status</label>
                        <select name="familyStatus" id="familyStatus" class="form-control mb-2" [(ngModel)]="user.familyStatus" name="familyStatus" #familyStatus="ngModel" [ngClass]="{ 'is-invalid': f.submitted && familyStatus.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="Single Person">Single Person</option>
                            <option value="Single Person with Children">Single Person with Children</option>
                            <option value="Two Person Household with Children">Two Person Household with Children</option>
                            <option value="Two Person Household without Children">Two Person Household without Children</option>
                            <option value="Other">Other</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && familyStatus.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="familyStatus.errors!.required">Family status is required</div>
                        </div>
                    </div>

                    <!-- Education -->
                    <div class="col md-6">
                        <label class="required-field">Education</label>
                        <select name="education" id="eductation" class="form-control mb-2" [(ngModel)]="user.education" name="education" #education="ngModel" [ngClass]="{ 'is-invalid': f.submitted && education.invalid }" required>
                            <option value="" selected="selected" disabled="disabled">-- select one --</option>
                            <option value="No formal education">No formal education</option>
                            <option value="Primary education">Primary education</option>
                            <option value="Secondary education">Secondary education or high school</option>
                            <option value="GED">GED</option>
                            <option value="Vocational qualification">Vocational qualification</option>
                            <option value="Bachelor's degree">Bachelor's degree</option>
                            <option value="Master's degree">Master's degree</option>
                            <option value="Doctorate or higher">Doctorate or higher</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && education.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="education.errors!.required">Education is required</div>
                        </div>
                    </div>
                </div>

                <!-- Input Row -->
                <div class="row mt-3" *ngIf="user.ageUnder18">

                    <!-- City -->
                    <div class="col-md-5">
                        <label class="required-field">City</label>
                        <input type="text" id="city" class="form-control mb-2" [(ngModel)]="user.city" name="city" #city="ngModel" [ngClass]="{ 'is-invalid': f.submitted && city.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && city.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="city.errors!.required">City is required</div>
                        </div>
                    </div>

                    <!-- State -->
                    <div class="col-md-3">
                        <label class="required-field">State</label>
                        <select name="state" id="state" class="form-control mb-2" placeholder="--" [(ngModel)]="user.state" name="state" #state="ngModel" [ngClass]="{ 'is-invalid': f.submitted && state.invalid }" required>
                          <option value="" selected="selected" disabled="disabled">--</option>
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="DC">District Of Columbia</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NE">Nebraska</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="OH">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WI">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </select>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && state.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="state.errors!.required">State is required</div>
                        </div>
                    </div>

                    <!-- County -->
                    <div class="col-md-4">
                        <label class="required-field">County</label>
                        <input type="text" id="county" class="form-control mb-2" [(ngModel)]="user.county" name="county" #county="ngModel" [ngClass]="{ 'is-invalid': f.submitted && county.invalid }" required>

                        <!-- Invalid -->
                        <div *ngIf="f.submitted && county.invalid" class="invalid-feedback">
                            <div class="mb-2" *ngIf="county.errors!.required">County is required</div>
                        </div>
                  </div>
                </div>
            </div>

            <!-- EULA -->
            <div class="col-md-12 mt-2" *ngIf="user.ageUnder18">
                <input type="checkbox" name="eula" id="eula" class="mb-2" name="eula" [(ngModel)]="eulaModel.eula" name="eula" #eula="ngModel" [ngClass]="{ 'is-invalid': f.submitted && eula.invalid }" required />
                <label for="eula" class="ml-2">I agree to the tool's <a href="../../../assets/End User Agreement.pdf" target="_blank">End-User License Agreement.</a></label>

                <!-- Invalid -->
                <div *ngIf="f.submitted && eula.invalid" class="invalid-feedback">
                    <div class="mb-2" *ngIf="eula.errors!.required">Required</div>
                </div>
            </div>

            <!-- Captcha -->
            <div class="col-md-12 mt-3" *ngIf="user.ageUnder18 && recaptchaEnabled">

                <div class="mb-4 input-field text-center">
                    <re-captcha #captcha="ngModel" [(ngModel)]="user.captcha" id="captcha" name="captcha" class="captcha" [ngClass]="{ 'is-invalid': f.submitted && captcha.invalid }" required></re-captcha>

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && captcha.invalid" class="invalid-feedback">
                        <div class="mb-2" *ngIf="captcha.errors!.required">Captcha is required</div>
                    </div>
                </div>
            </div>

            <!-- Input Row -->
            <div class="row mt-3">
                <!-- Next page button -->
                <div class="text-center mt-2">
                    <button type="submit" class="mb-4 btn" *ngIf="!user.ageUnder18" [class.disabled]="geolocating">Next</button>
                    <button type="submit" class="mb-4 btn" *ngIf="user.ageUnder18" [class.disabled]="submitting || geolocating">Finish</button>
                </div>

                <!-- Login Link-->
                <p class=" mb-4 text-center ">Already have an account?
                    <a [routerLink]=" '/login' ">Login</a>
                </p>
            </div>
        </form>
    </div>
</section>
